/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileSubscription } from '../../models/profile-subscription';
import { ProfileSubscriptionSave } from '../../models/profile-subscription-save';

export interface UpdateProfileSubscription$Params {
  id: number;
  profileSubscriptionId: number;
      body: ProfileSubscriptionSave
}

export function updateProfileSubscription(http: HttpClient, rootUrl: string, params: UpdateProfileSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileSubscription>> {
  const rb = new RequestBuilder(rootUrl, updateProfileSubscription.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('profileSubscriptionId', params.profileSubscriptionId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileSubscription>;
    })
  );
}

updateProfileSubscription.PATH = '/rest/admin/profile/{id}/subscription/{profileSubscriptionId}';
